// src/hooks/useSSEToken.js
import { useState, useEffect } from "react";

const BASE_URL = "https://vivebackend-a5hdfhhtbphgd4ed.canadacentral-01.azurewebsites.net";

export const useSSEToken = (userId, onNewToken) => {
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!userId) return;

    const evtSource = new EventSource(`${BASE_URL}/api/token-stream/${userId}`);

    evtSource.onopen = () => {
      console.log("✅ SSE conectado");
      setConnected(true);
    };

    evtSource.onmessage = (event) => {
      console.log("📥 Nuevo token recibido por SSE:", event.data);
      if (onNewToken) {
        onNewToken(event.data); // Callback que recibe el nuevo token
      }
    };

    evtSource.onerror = (err) => {
      console.error("❌ Error en SSE:", err);
      evtSource.close();
      setConnected(false);
    };

    return () => {
      console.log("⚠ Cerrando conexión SSE");
      evtSource.close();
    };
  }, [userId, onNewToken]);

  return { connected };
};
